
const digest = 'd1a3ee04026611df25ef3525942c68069ffdc66770174ece34627c75b8010b08';
const classes = {"wrapper":"_wrapper_qc39z_1","icon":"_icon_qc39z_10","title":"_title_qc39z_18"};
const css = `._wrapper_qc39z_1 {
  display: flex;
  flex-direction: row;
  font-family: Rubik, sans-serif;
  cursor: pointer;
  align-items: center;
  margin: 20px 0;
}

._icon_qc39z_10 {
  width: 20px;
  height: 20px;
  background: url("/dist/icons/react/circle-plus-solid-blue.svg") no-repeat center right;
  background-size: contain;
  margin-right: 5px;
}

._title_qc39z_18 {
  font-size: 14px;
  color: #000000;
  text-decoration: underline;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  